import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';

import BrIcons from '@components/BrIcons';
import './columns.scss';

export default function EditDeleteHTMLColumn({ row, col, cell }) {
  const { onEdit, onDelete } = col.columnConfig;
  // By default consider both to be true but can be overriden at cell level.
  const { isEditable = true, isDeletable = true, isReadOnly = false, readOnlyToolTip = null } = cell;
  const editIcon = isEditable && <BrIcons.Edit className="edit-row-icon" onClick={() => onEdit(row, cell.value)} />;
  const deleteIcon = isDeletable && (
    <BrIcons.Delete className="del-row-icon" onClick={() => onDelete(row, cell.value)} />
  );
  const readOnlyTag = readOnlyToolTip ? (
    <Tooltip arrow title={readOnlyToolTip} placement="right">
      <span>
        <BrIcons.ReadOnly className="read-only-tag" disableHover />
      </span>
    </Tooltip>
  ) : (
    <BrIcons.ReadOnly className="read-only-tag" />
  );

  return (
    <div className="br-edit-delete-html-column">
      <span className="content">{cell.displayElement}</span>
      {cell.disabled ? (
        ''
      ) : isReadOnly ? (
        readOnlyTag
      ) : (
        <span>
          {editIcon}
          {deleteIcon}
        </span>
      )}
    </div>
  );
}

EditDeleteHTMLColumn.defaultWidth = 240;

EditDeleteHTMLColumn.propTypes = {
  cell: PropTypes.shape({
    value: PropTypes.any,
    displayElement: PropTypes.element, // JSX element that you want to show
    isEditable: PropTypes.bool,
    isDeletable: PropTypes.bool,
  }).isRequired,
  col: PropTypes.shape({
    // column config
    columnConfig: PropTypes.shape({
      onEdit: PropTypes.func.isRequired, // (row, value:type) :=> {}
      onDelete: PropTypes.func.isRequired,
    }).isRequired,
  }).isRequired,
};
